<template>
  <div>
    <div class="mt-1 p-2">
      <b-form-input
        v-model="searchPath"
        type="search"
        placeholder="Buscar"
      ></b-form-input>
    </div>
    <b-list-group flush class="filterList">
      <b-list-group-item
        v-for="item in listItems"
        :key="item.id"
        href="#"
        @click="$emit('input', item.id)"
      >
        {{ item.label }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchPath: ""
    };
  },
  props: {
    filterItems: Array
  },
  computed: {
    listItems: function() {
      let result = [];
      if (this.searchPath === "") {
        result = this.filterItems;
      } else {
        const searchReg = new RegExp(this.searchPath, "i");
        this.filterItems.forEach(function(element) {
          if (element.label.search(searchReg) !== -1) {
            result.push(element);
          }
        });
      }
      return result;
    }
  }
};
</script>
